<script>
export default {
  name: "OperationsModal.vue",

  props: {

  },

  data() {
    return {
      showModal: false,
      windowClass: 'inline-block align-bottom rounded-lg text-left transition-all sm:my-8 sm:align-middle sm:w-full xl:max-w-screen-xl lg:max-w-screen-lg md:max-w-screen-md sm:max-w-screen-sm max-w-screen-xs'
    };
  },

  methods: {
    open() {
      this.showModal = true;
      this.$emit('open');
    },
    close() {
      this.showModal = false;
      this.$emit('close');
    },
    cancel() {
      this.showModal = false;
    }
  }
}
</script>

<template>
  <div>
    <div class="fixed z-100 inset-0" v-show="showModal">
      <div>
        <div class="fixed inset-0 bg-grey opacity-50"></div>
      </div>
      <div class="fixed z-1000 inset-0 flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
        <!-- This element is to trick the browser into centering the modal contents. -->
        <span class="hidden sm:inline-block sm:align-middle sm:h-screen"></span>&#8203;

        <div :class="windowClass" role="dialog" aria-modal="true"
             aria-labelledby="modal-headline">
          <div class="sm:flex sm:items-start flex flex-col">
            <slot></slot>
          </div>
          <div class="bg-secondary footer-shadow rounded-b px-2 pb-3 pt-1 sm:flex sm:flex-row-reverse">
            <slot name="footer" :close="close" :cancel="cancel"></slot>
          </div>
        </div>
      </div>
    </div>

    <slot name="toggle" :open="open"></slot>
  </div>
</template>
